export default __webpack_public_path__ + "static/media/notepad_x.d7749ee2.svg";